import type { SequenceI } from "tweenly"
import React from "react"
import ImageContainer from "./ImageContainer"

interface Props {
    object: SequenceI
    isHiding: boolean
    isLocking: boolean
    isRootTicker: boolean
    canvasScaleCoef: number
    borderCoef: number
    handleSelectObject: (
        event: React.MouseEvent,
        objectId: string,
        animationIds: string[],
        shiftKey: boolean
    ) => void
}

const SequenceContainer = ({
    object,
    isHiding,
    isLocking,
    isRootTicker,
    canvasScaleCoef,
    borderCoef,
    handleSelectObject,
}: Props) => {
    return (
        <ImageContainer
            object={object}
            isHiding={isHiding}
            isLocking={isLocking}
            isRootTicker={isRootTicker}
            canvasScaleCoef={canvasScaleCoef}
            borderCoef={borderCoef}
            handleSelectObject={handleSelectObject}
        />
    )
}

export default SequenceContainer
